import { identity } from 'lodash-es';
import { createSelector } from 'reselect';

const getServicesFormInitialValues = (services: any) => services;

const servicesFormInitialValuesSelector = createSelector(getServicesFormInitialValues, identity);

export default servicesFormInitialValuesSelector;
